import { formatDate } from 'ClientService';

export const FormatDate = ({ value, record }) => formatDate(value);
